import React from 'react'
import { Icon } from '@frontend/pole-ui/lib/components/Icon'
import { CheckIcon } from '@frontend/pole-ui/lib/components/Icon/svg/CheckIcon'
import { formatLocalizedString } from '@/utils/formatUtils'
import type { TLandingLoanTermProps } from '../../types'
import './styles.scss'

export const LandingLoanTerm: React.FC<TLandingLoanTermProps> = ({ group }) => {
  return (
    <div className="landingLoanTerm">
      <table className="landingLoanTerm__table">
        {group.columnHeaders.length > 0 && (
          <tr className="landingLoanTerm__termHeaders">
            <th className="landingLoanTerm__termHeader" />
            {group.columnHeaders.map(header => (
              <th className="landingLoanTerm__termHeader h5" key={header}>
                {header}
              </th>
            ))}
          </tr>
        )}
        {group.terms.map(term => (
          <tr key={term.title} className="landingLoanTerm__property">
            <th className="landingLoanTerm__propertyHeader h5">{term.title}</th>
            {term.clauses.map((clause, index) => (
              <td key={index} className="landingLoanTerm__term" colSpan={clause.columns}>
                <div className="landingLoanTerm__termDetails">
                  {clause.details.map(detail => (
                    <div key={detail.text} className="landingLoanTerm__termDetail">
                      {detail.checked && <Icon className="landingLoanTerm__termCheck" component={<CheckIcon />} />}
                      <span>{formatLocalizedString(detail.text, detail.formatOptions ?? {})}</span>
                    </div>
                  ))}
                </div>
              </td>
            ))}
          </tr>
        ))}
      </table>
    </div>
  )
}
